const state = {
  user: {},
  // 插件端的userToken
  userToken: null,
  showUserDetail: false,
  userPopupVisible: false,
  userInfoCompleted: false,
  ssoUrl: ''
}
const getters = {
  user: (state) => { return state.user },
  userToken: (state) => { return state.userToken },
  showUserDetail: (state) => { return state.showUserDetail },
  userPopupVisible: (state) => state.userPopupVisible,
  ssoUrl: (state) => state.ssoUrl,
}
const mutations = {
  setUser(state, data) {
    state.user = data
  },
  setUserToken(state, data) {
    state.userToken = data
  },
  setShowUserDetail(state, value) {
    state.showUserDetail = value
  },
  setSsoUrl(state, value) {
    state.ssoUrl = value
  }
}
const actions = {
  // 获取用户信息
  async loadUserInfo({ commit }, headers = {}) {
    try {
      const res = await this.$api.user.getUserInfo(headers)
      commit('setUser', res || {})
    } catch (error) {
      commit('setUser', {})
    }
  },
  
  // 获取用户信息
  async loadUserInfoBySso({ commit }, params) {
    try {
      const res = await this.$api.user.getUserInfoBySso(params)
      commit('setUser', res || {})
    } catch (error) {
      commit('setUser', {})
    }
  },
  async loadSsoUrl({ commit }, dest) {
    try {
      const res = await this.$api.user.ssoUrl({ dest: dest })
      commit('setSsoUrl', res || {})
    } catch (error) {
      commit('setSsoUrl', {})
    }
  },
  // 退出登录
  async logoutPlugin({ commit }, payload) {
    try {
      const { token } = payload
      await this.$api.user.logoutPlugin({ Authorization: `Bearer ${token}` })
      commit('setUser', {})
    } catch (error) {
      console.log('退出失败')
      const e = JSON.parse(error.message)
      this.tip = e.message
    }
  },
  // 退出登录
  async logout({ commit }, payload) {
    try {
      // 先校验用户是否还在登录态
      const res = await this.$api.user.getUserInfo()
      if (res) {
        const { dest, platform } = payload
        const locationUrl = await this.$api.user.logout({ dest: dest })
        if (platform === 'web') {
          window.location = locationUrl
        }
      } else {
        commit('setUser', {})
      }
    } catch (error) {
      console.log('退出失败')
      const e = JSON.parse(error.message)
      this.tip = e.message
    }
  },
  setUserInfoCompleted(state, value) {
    state.userInfoCompleted = value
  },
  setUserPopupVisible(state, value) {
    state.userPopupVisible = value
    if (window.userPopupCallback) {
      if (!value) {
        window.userPopupCallback()
      }
    }
  },
  setSignInPopupVisible(state, value) {
    state.signInPopupVisible = value
    if (window.signInPopupCallback) {
      if (!value) {
        window.signInPopupCallback()
      }
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
